import { StoreState } from 'src/types';
import {
  LanguageAction,
  INITIALIZE_LANGUAGE,
  SIGNAL_LANGUAGE_READY
} from 'src/actions/i18n';

const languageReady = (
  state: StoreState['languageReady'],
  action: LanguageAction
) => {
  switch (action.type) {
    case SIGNAL_LANGUAGE_READY:
      return true;
    case INITIALIZE_LANGUAGE:
      return false;
    default:
      return state || false;
  }
};

export default languageReady;

export function getLanguageReady(state: StoreState) {
  return state.languageReady;
}
